import { render, staticRenderFns } from "./UpdateBrandDialogVersion2.vue?vue&type=template&id=562bf8ec&scoped=true"
import script from "./UpdateBrandDialogVersion2.vue?vue&type=script&lang=js"
export * from "./UpdateBrandDialogVersion2.vue?vue&type=script&lang=js"
import style0 from "./UpdateBrandDialogVersion2.vue?vue&type=style&index=0&id=562bf8ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bf8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562bf8ec')) {
      api.createRecord('562bf8ec', component.options)
    } else {
      api.reload('562bf8ec', component.options)
    }
    module.hot.accept("./UpdateBrandDialogVersion2.vue?vue&type=template&id=562bf8ec&scoped=true", function () {
      api.rerender('562bf8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/UpdateBrandDialogVersion2.vue"
export default component.exports